import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-death',
  templateUrl: './view-animal-death.component.html',
  styleUrls: ['./view-animal-death.component.css']
})
export class ViewAnimalDeathComponent implements OnInit {
  getanimalsamplesviewApi: any;
  testdate: any;
  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router, private commonService: CommonService) { }

  async ngOnInit() {
    let DeathId = sessionStorage.getItem('deathId');
    this.getanimalsamplesviewApi = "/animal_management/death/" + DeathId;
    (await this.commonService.getApi(this.getanimalsamplesviewApi)).subscribe(
      res => {
        console.log(res.data);
        var date = res.data.tnam_dth_date_of_death;
        this.testdate = date.split('T');
        $("#deathcause").text(res.data.tnam_dth_cause_of_death)
      })
  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }

}
